import { RestApi } from "../services/rest-api";
import { YesNo } from "../types/yes-no.type";
import { AccountMaster, BrandMaster, ColorMaster, ItemMaster } from "./masters.model";
import { PagingDataModel } from "./paging.model";

export interface PurchaseOrderItemModel {
  item: ItemMaster;
  description: string;
  color: ColorMaster;
  brand: BrandMaster;
  bag: number;
  qty: number;
  rate: number;
  gst_per: number;
  net_rate: number;
  amt: number;
}

export interface PurchaseOrderModel {
  id?: number;
  account?: AccountMaster;
  ac_name?: string;
  po_no: string;
  po_date: string;
  delivery: string,
  closed_status: string;
  remarks?: string;
  items: Array<PurchaseOrderItemModel>;
  bag: number;
  qty: number;
  amt: number;
}

export interface PurchaseOrderExtendedModel extends PurchaseOrderModel {
  recd_qty: number;
  recd_per: number;
}

export interface RptPurchaseOrderItemBalanceModel {
  item_id: number;
  item_name: string;
  ordered_qty: number;
  recd_qty: number;
}

export interface RptItemRecdModel {
  v_no: string;
  v_date: string;
  qty: number;
  balance_qty?: number;
}

export interface RptItemOrderModel extends RptItemRecdModel {
  id: number;
  ac_name: string;
  delivery?: string;
  recd_qty: number;
  closed_status: YesNo;
}

export interface RptItemOrderRecdCombinedModel {
  order: RptItemOrderModel;
  recd: Array<RptItemRecdModel>;
}

export const fetchPurchaseOrderList = async (page: number, inputs: any, authInfo: any) => {
  return await RestApi<PagingDataModel<PurchaseOrderExtendedModel>>('post', `purchaseOrderList?p=${page}`, inputs, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

export const fetchPurchaseOrderShow = async (id: string, authInfo: any) => {
  return await RestApi<any>('post', 'purchaseOrderShow', { id }, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

export const deletePurchaseOrder = async (id: number, authInfo: any) => {
  return await RestApi<any>('post', 'deletePurchaseOrder', { id }, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

export const fetchRptPoPiItemBalance = async (authInfo: any) => {
  return await RestApi<Array<RptPurchaseOrderItemBalanceModel>>('post', 'rptPoPiItemBalance', {}, authInfo.user.authorization).then(function (response) {
    return response;
  });
};


export const fetchRptItemPoPiBalance = async (id: number, authInfo: any) => {
  return await RestApi<Array<RptItemOrderRecdCombinedModel>>('post', 'rptItemPoPiBalance', { id }, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

export const markPurchaseOrderClose = async (id: number, authInfo: any) => {
  return await RestApi('post', 'markPurchaseOrderClose', { id }, authInfo.user.authorization).then(function (response) {
    return response;
  });
};
